import React, { useEffect, useState, useRef } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { Button, Accordion, AccordionItem } from 'carbon-components-react'

const KnovoHelp = (props) => {
  const {
    tutorTalking,
    showCC,
    isHideSubtitle,
    onBotAnimeClick,
    onKnovoHelpSelected,
    onBotAnimeClose,
    Completed,
    isActive,
    isPractice,
    onHelpNeeded,
    isGuidedActivity,
    guidedData,
    onGuidedClick,
    isContained,
    isSmartCanvas
  } = props
  const [isShowAnswer, setIsShowAnswer] = useState(false)

  useEffect(() => {
    onKnovoHelpSelected('showAnswer', isShowAnswer)
  }, [isShowAnswer])

  return (
    <div className='knovo-help-container'>
      <div className='knovo-help-heading'>
        <p className='knovo-help-lebel1'> Need help?</p>
        <div
          className='header-circle-button-close'
          style={{ width: '20px', height: '20px' }}
          onClick={() => {
            onBotAnimeClose()
          }}
        >
          <CloseIcon
            style={{
              height: '15px',
              width: '15px',
              color: '#ffffff'
            }}
          />
        </div>
      </div>
      {isSmartCanvas ? (
        <div className='knovo-help-options'>
          {!isContained && isGuidedActivity && (
            <Button
              className='help-options-label bg-brand'
              onClick={() => {
                onGuidedClick('guided')
              }}
            >
              Guided Activity
            </Button>
          )}
        </div>
      ) : (
        <div className='knovo-help-options'>
          {!isContained && isGuidedActivity && isPractice && (
            <Button
              className='help-options-label bg-brand'
              onClick={() => {
                onGuidedClick('guided')
              }}
            >
              Guided Activity
            </Button>
          )}
          {/* <div className='help-accord-cont'>
         <Accordion>
           <AccordionItem
             title='Yes, I Need Help'
             className='knovo-accord-item'
           >
             <p
               className='knovo-help-link-label'
               onClick={() => {
                 onHelpNeeded('contained')
               }}
             >
               Guided Tutoring with Knova
             </p>
             <p
               className='knovo-help-link-label'
               onClick={() => {
                 onHelpNeeded('video')
               }}
             >
               Watch a Video
             </p>
           </AccordionItem>
         </Accordion>
       </div> */}
          <Button
            className='help-options-label bg-brand'
            onClick={() => {
              onKnovoHelpSelected('alChatBot')
            }}
          >
            Chat with Knova
          </Button>
          <Button
            className='help-options-label bg-brand'
            onClick={() => {
              onKnovoHelpSelected('instruction')
            }}
          >
            Activity Instructions
          </Button>
          <Button
            className='help-options-label bg-brand'
            onClick={() => {
              onKnovoHelpSelected('walkthrough')
            }}
          >
            Knova Tour
          </Button>
          <Button
            className={
              isShowAnswer
                ? 'help-options-label bg-green-sub'
                : 'help-options-label bg-brand'
            }
            onClick={() => {
              setIsShowAnswer((isShowAnswer) => !isShowAnswer)
            }}
            disabled={
              isPractice ? false : Completed === 0 && isActive ? true : false
            }
          >
            Show Answer
          </Button>
        </div>
      )}
    </div>
  )
}

export { KnovoHelp }
